/**
 * Alpine.store('a11y') — toggles the `contrast` and `bigger_font` classes on <html>.
 * Requires window.a11yPrefs (import a11y-prefs.js first).
 */

document.addEventListener('alpine:init', () => {
    window.Alpine.store('a11y', {
        contrast: false,
        bigger_font: false,

        init() {
            this.contrast = window.a11yPrefs.get('contrast') === true;
            this.bigger_font = window.a11yPrefs.get('bigger_font') === true;
            this.apply();
        },

        toggle(key) {
            this[key] = !this[key];
            window.a11yPrefs.set(key, this[key]);
            this.apply();
        },

        apply() {
            const html = document.documentElement;
            html.classList.toggle('contrast', this.contrast);
            html.classList.toggle('bigger_font', this.bigger_font);
        },
    });
});
